import React from 'react';
import './MessageItem.css';
import { svg_del } from '../static/svgs';

const MessageItem = ({ message, isSelf, deleteBotMessage }) => {

    const handleClickDelete = () => {
        deleteBotMessage(message.tg_msg_id, message.to_id);
    };

    return (
        <div className={`message-container ${message.sender === 'BotTax' ? 'other' : 'self'}`}>
            {/* <div className="message-bubble">
                <strong>{message.sender}</strong>
                <div>
                    {message.text}
                </div>
                {message.tg_msg_id !== 0 &&
                    <div className='svg_del' onClick={handleClickDelete}>
                        {svg_del}
                    </div>
                }
            </div> */}
            <div className="message-bubble">
                <strong>{message.sender}</strong>
                <div>{message.text}</div>

                {/* Блок с оценкой и комментарием, если они есть */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                {(message.rating || message.rating_comment) && (
                    <div className="message-rating">
                        <span><b>Оценка: {message.rating ?? "Нет"}</b></span>
                        <span>  Комментарий: {message.rating_comment}</span>
                    </div>
                )}

                {/* Иконка удаления */}
                {message.tg_msg_id !== 0 && (
                    <div className="message-footer">
                        <div className='svg_del' onClick={handleClickDelete}>
                            {svg_del}
                        </div>
                    </div>
                )}
                </div>
            </div>


        </div>
    );
};

export default MessageItem;

